import React from "react";
import { Form, Row } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import "~/i18n.js";

const CreateTextLabel = (props) => {
  const { field, isChild, styleSheet, t } = props;

  return (
    <>
      <Form.Group
        controlId={`formlabel-${field.type}`}
        as={Row}
        style={{
          flexWrap: "nowrap",
          marginLeft: "0px",
          marginRight: "0px",
          marginBottom: styleSheet?.compact ? "5px" : "10px",
          flexGrow: "1",
        }}
      >
        <Form.Label column className="iflow-form-label-fix">
          {field.text.includes(":") ? field.text : t(field.text)}
        </Form.Label>
        <Form.Label
          column
          //className="iflow-form-label-fix"
          style={{
            fontWeight: "500",
            paddingRight: "0px",
            paddingLeft: "0px",
          }}
        >
          {" "}
          {field.value}
          {field.suffix ? field.suffix : ""}
        </Form.Label>
      </Form.Group>
      {styleSheet?.highLightRows && !isChild && <hr />}
    </>
  );
};
export default withNamespaces()(CreateTextLabel);
